import { render, staticRenderFns } from "./addHpbr.vue?vue&type=template&id=21d876a9"
import script from "./addHpbr.vue?vue&type=script&lang=js"
export * from "./addHpbr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports